import React from 'react';
import styled from 'styled-components';
import { colors, fonts } from '../styles/globals';

const PainContainer = styled.section`
  background-color: ${colors.white};
  padding: 80px 20px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const PainContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const PainTitle = styled.h2`
  font-family: ${fonts.playfair};
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
  line-height: 1.2;
`;

const PainSubtitle = styled.p`
  font-family: ${fonts.inter};
  font-size: 1.2rem;
  font-weight: 500;
  color: ${colors.text};
  margin-bottom: 40px;
  line-height: 1.5;
`;

const PainText = styled.div`
  background: linear-gradient(135deg, ${colors.background} 0%, #F8FBFF 100%);
  border-radius: 20px;
  padding: 40px;
  margin-bottom: 30px;
  border-left: 4px solid ${colors.accent};

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const PainQuestion = styled.p`
  font-family: ${fonts.inter};
  font-size: 1.1rem;
  font-weight: 500;
  color: ${colors.text};
  margin-bottom: 20px;
  line-height: 1.6;
`;

const PainStatement = styled.div`
  background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.darkBackground} 100%);
  color: ${colors.white};
  border-radius: 16px;
  padding: 30px;
  margin-top: 30px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.2;
  }

  @media (max-width: 768px) {
    padding: 25px 20px;
  }
`;

const StatementText = styled.p`
  font-family: ${fonts.playfair};
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.4;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

function PainSection() {
  return (
    <PainContainer>
      <PainContent>
        <PainTitle>El dolor real: No es técnica, es emoción</PainTitle>
        <PainSubtitle>
          Tu miedo a hablar no se soluciona con tips. Se sana desde la raíz.
        </PainSubtitle>

        <PainText>
          <PainQuestion>
            ¿Evitas hablar en público? ¿Te bloqueas, tiemblas o sientes que tu voz no es suficiente?
          </PainQuestion>
        </PainText>

        <PainStatement>
          <StatementText>
            No necesitas más cursos.<br />
            Necesitas sanar lo que callaste durante años y reconectar con tu verdad.
          </StatementText>
        </PainStatement>
      </PainContent>
    </PainContainer>
  );
}

export default PainSection; 